/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolvedCaseNoteTemplateResponse
 */
export interface ResolvedCaseNoteTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof ResolvedCaseNoteTemplateResponse
     */
    content: string;
}

/**
 * Check if a given object implements the ResolvedCaseNoteTemplateResponse interface.
 */
export function instanceOfResolvedCaseNoteTemplateResponse(value: object): value is ResolvedCaseNoteTemplateResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ResolvedCaseNoteTemplateResponseFromJSON(json: any): ResolvedCaseNoteTemplateResponse {
    return ResolvedCaseNoteTemplateResponseFromJSONTyped(json, false);
}

export function ResolvedCaseNoteTemplateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolvedCaseNoteTemplateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function ResolvedCaseNoteTemplateResponseToJSON(json: any): ResolvedCaseNoteTemplateResponse {
    return ResolvedCaseNoteTemplateResponseToJSONTyped(json, false);
}

export function ResolvedCaseNoteTemplateResponseToJSONTyped(value?: ResolvedCaseNoteTemplateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
    };
}

